<template>
  <Modal v-model="passThroughValue" :mfg="mfg" :title="this.$i18n.t(`modal${mfgCapped}.headline`)" :customerConfig="customerConfig" :showCloseButton="showCloseButton" :activeStep="activeStep" class="enrollment-modal">
    <div tabindex="-1">
      <p style="margin-top: 16px; white-space: pre-line;">
        {{ $t(`modal${mfgCapped}.introduction`) }}
      </p>
      <div v-if="copy.step1 && copy.step2 && copy.step3" class="row modal-tiles">
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div
            class="modal-tiles--tile--icon"
            style="position: relative; top: 15px;"
          >
            <div v-if="icons.default">
              <div class="icon-sphere">
                <p class="number">1</p>
              </div>
            </div>
            <div v-else>
              <img class="icon-main" id="device" :src="icons.step1.mainIcon" alt="">
              <div class="icon-sub">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle v-bind:style="{ fill: theme.primaryColor }" id="Ellipse 6" cx="16.98" cy="16.98" r="16.98" fill="#016699"/>
                  <image x="7" y="6" :href="icons.step1.subIcon" />
                </svg>
              </div>
            </div>
          </div>
          <p v-if="copy.step1Header" class="modal-tiles--tile--header">
            {{ $t(`modal${mfgCapped}.step1Header`) }}
          </p>
          <p class="modal-tiles--tile--desc">
            {{ $t(`modal${mfgCapped}.step1`) }}
          </p>
        </div>
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div
            class="modal-tiles--tile--icon"
            style="position: relative; top: 15px;"
          >
            <div v-if="icons.default">
              <div class="icon-sphere">
                <p class="number">2</p>
              </div>
            </div>
            <div v-else>
              <img class="icon-main" :src="icons.step2.mainIcon" alt="">
              <div class="icon-sub">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle v-bind:style="{ fill: theme.primaryColor }" id="Ellipse 6" cx="16.98" cy="16.98" r="16.98" fill="#016699"/>
                  <image x="10" y="10" :href="icons.step2.subIcon" />
                </svg>
              </div>
            </div>
          </div>
          <p v-if="copy.step2Header" class="modal-tiles--tile--header">
            {{ $t(`modal${mfgCapped}.step2Header`) }}
          </p>
          <p class="modal-tiles--tile--desc">
            {{ $t(`modal${mfgCapped}.step2`) }}
          </p>
        </div>
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div
            class="modal-tiles--tile--icon"
            style="position: relative; top: 15px;"
          >
            <div v-if="icons.default">
              <div class="icon-sphere">
                <p class="number">3</p>
              </div>
            </div>
            <div v-else>
              <img class="icon-main" id="file" :src="icons.step3.mainIcon" alt="">
              <div class="icon-sub">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle v-bind:style="{ fill: theme.primaryColor }" id="Ellipse 6" cx="16.98" cy="16.98" r="16.98" fill="#016699"/>
                  <image x="10" y="5" :href="icons.step3.subIcon" />
                </svg>
              </div>
            </div>
          </div>
          <p v-if="copy.step3Header" class="modal-tiles--tile--header">
            {{ $t(`modal${mfgCapped}.step3Header`) }}
          </p>
          <p class="modal-tiles--tile--desc">
            {{ $t(`modal${mfgCapped}.step3`) }}
          </p>
        </div>
      </div>
      <div class="row completion-instructions">
        <div class="col">
          <p v-if="copy.ending">
            {{ $t(`modal${mfgCapped}.ending`) }}
          </p>
          <button
            v-bind:style="{ backgroundColor: theme.primaryColor }"
            v-on:click="saveAndRedirect();"
          >
          {{ $t(`modal${mfgCapped}.button`) }}
          </button>
        </div>
      </div>
      <p class="text-center">
        {{ $t(`modal${mfgCapped}.supportEmail`) }}
        <a
          v-bind:style="{ color: theme.primaryColor }"
          v-bind:href="'mailto:' + supportEmail"
        >
          {{ supportEmail }}
        </a>
      </p>
    </div>
  </Modal>
</template>

<script>
import storage from '@/services/storage';
import Modal from './Modal.vue';
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'modal-enrollment',
  props: ['value', 'opts', 'customerConfig', 'activeStep'],
  inject: {
    theme: { default: defaultTheme },
  },
  data() {
    return {
      supportEmail: 'support@virtual-peaker.com',
      passThroughValue: false,
      showCloseButton: true,
    };
  },
  computed: {
    icons() {
      switch (this.mfg) {
        case 'ecobee':
          return {
            step1: {
              mainIcon: require('@/assets/icons/mobile.svg'),
              subIcon: require('@/assets/icons/house-icon.svg'),
            },
            step2: {
              mainIcon: require('@/assets/icons/house.svg'),
              subIcon: require('@/assets/icons/cursor-icon.svg'),
            },
            step3: {
              mainIcon: require('@/assets/icons/file.svg'),
              subIcon: require('@/assets/icons/lightning-bolt.svg'),
            },
          };
        default:
          return { default: true };
      }
    },
    mfg() {
      return this.opts.enrollmentModal.mfg;
    },
    mfgCapped() {
      return this.mfg.charAt(0).toUpperCase() + this.mfg.slice(1);
    },
    copy() {
      const locales = require.context('../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
      const selectedLang = storage.get('selectedLanguage');
      const localization = locales(`./${selectedLang}.json`);
      return localization[`modal${this.mfgCapped}`];
    },
  },
  watch: {
    value() {
      this.passThroughValue = this.value;
    },
    passThroughValue() {
      this.$emit('input', this.passThroughValue);
    },
  },
  mounted() {
    this.supportEmail = this.customerConfig.supportEmail;
    this.passThroughValue = this.value;
  },
  methods: {
    saveAndRedirect() {
      if (this.opts.redirectUrl) window.open(this.opts.redirectUrl, '_blank');
      if (this.mfg === 'tesla' && this.activeStep === 1) this.$route.meta.bypass = true;

      this.$router.push({ name: 'success', params: { type: this.mfg } });
    },
  },
  components: { Modal },
};

</script>

<style lang="scss">

.enrollment-modal {

  p {
    margin: 9px 0 9px 0;
  }

  @media (max-width: 576px) {
    p {
      margin: 9px 16px;
    }
  }

  .row.completion-instructions {
    text-align: center;
    width: auto;

    @media (max-width: 576px) {
      padding: 0 24px;
    }

    .col {
      button {
        @media (max-width: 576px) {
          margin: 8px 0;
          width: 100%;
        }
      }
    }
  }

  .row.modal-tiles {
    padding: 0 5px;
    width: auto;

    div.modal-tiles--tile {
      background-color: white;
      margin: 10px;
      padding: 10px;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      @media (max-width: 576px) {
        margin: 4px 32px;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
      }

      p {
        text-align: center;
        font-style: normal;
        padding-right: 7px;
        padding-left: 7px;

        &.modal-tiles--tile--desc {
          font-size: 12px;
          color: #4F4F4F;
        }

        &.modal-tiles--tile--header {
          font-size: 14px;
          color: #016699;
        }
      }

      .modal-tiles--tile--icon {
        display: inline-block;
        position: relative;
        margin-left: auto;
        margin-right: auto;

        .icon-main {
          color: #A6B1C3;
          display: inline-block;
        }

        #device {
          width: 40px;
        }

        .icon-sub {
          position: relative;
          display: block;
          right: -30px;
          top: -20px;
        }

        .icon-sphere {
          height: 48px;
          width: 48px;
          border-radius: 50%;
          background-color: #016699;
          display: flex;
          justify-content: center;
          align-items: center;

          .number {
            color: white;
            font-size: 24px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
